<template>
    <div>
        <div class="row g-4 settings-section">
            <div class="col-12 col-md-4">
                <h3 class="section-title">Edit Profile</h3>
                <div class="section-intro"></div>
            </div>
            <div class="col-12 col-md-8">
                <div class="app-card app-card-settings shadow-sm p-4">

                    <div class="app-card-body">
                        <form class="settings-form">
                            <div class="mb-3">
                                <label for="name" class="form-label">Full Name</label>
                                <input id="name" type="text" class="form-control" name="name" v-model="user.name"
                                    required autocomplete="off">
                                <span v-if="errors.name" class="invalid-feedback d-block">{{ errors.name[0] }}</span>
                            </div>
                            <div class="mb-3">
                                <label for="email" class="form-label">Email Address</label>
                                <input id="email" type="email" class="form-control" name="email" v-model="user.email"
                                    required autocomplete="email">
                                <span v-if="errors.email" class="invalid-feedback d-block">{{ errors.email[0] }}</span>
                            </div>
                            <button type="submit" class="btn app-btn-primary" @click.prevent="updateUserProfile">Save
                                Changes</button>
                        </form>
                    </div>

                </div>
            </div>
        </div>

        <hr class="mb-4">

        <div class="row g-4 settings-section">
            <div class="col-12 col-md-4">
                <h3 class="section-title">Reset Password</h3>
                <div class="section-intro"></div>
            </div>
            <div class="col-12 col-md-8">
                <div class="app-card app-card-settings shadow-sm p-4">

                    <div class="app-card-body">
                        <form class="settings-form">
                            <div class="mb-3">
                                <label for="current-password" class="form-label">Old Password</label>
                                <input id="current-password" type="password" class="form-control"
                                    v-model="user.old_password" required autocomplete="off">

                                <span v-if="errors.old_password" class="invalid-feedback d-block">{{
                                    errors.old_password[0] }}</span>
                            </div>
                            <div class="mb-3">
                                <label for="password" class="form-label">New Password</label>
                                <input id="password" type="password" class="form-control" v-model="user.password"
                                    required autocomplete="off">

                                <span v-if="errors.password" class="invalid-feedback d-block">{{ errors.password[0]
                                    }}</span>
                            </div>
                            <div class="mb-3">
                                <label for="password-confirm" class="form-label">Confirm New Password</label>
                                <input id="password-confirm" type="password" class="form-control"
                                    v-model="user.password_confirmation" required autocomplete="off">
                            </div>
                            <button type="submit" class="btn app-btn-primary" @click.prevent="resetPassword">Save
                                Changes</button>
                        </form>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "profileComponent",

    data() {
        return {
            user: {
                email: null,
                name: null
            },
            errors: {}
        }
    },

    created() {
        this.getUser();
    },

    methods: {
        getUser: function () {
            axios.get(`/get-profile`)
                .then(response => {
                    this.user = response.data.user
                    this.errors = {}
                })
        },

        updateUserProfile: function () {
            axios.post(`/profile-update`, this.user).then(response => {
                Toast.fire({ icon: 'success', title: response.data.message })
                this.getUser()
            }).catch(error => {
                this.errors = error.response.data.errors
            })
        },

        resetPassword: function () {
            axios.post(`/profile-reset-password`, this.user).then(response => {
                Toast.fire({ icon: 'success', title: response.data.message })
                this.getUser()
            }).catch(error => {
                this.errors = error.response.data.errors
            })
        },
    }

}
</script>

<style scoped></style>
